import React from 'react';

const ModeloInformacoesComplementaresContext = React.createContext();

export default ModeloInformacoesComplementaresContext;
